import React from "react";
import {Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@material-ui/core";
import {Values} from "Tools/Values";
import {NoContentSign} from "@src/Components/Pages/Main/Content/Persons/PersonForm/styles";
import {Location, MetaData} from "@src/Interfaces/Entity/Location";
import {IAuthStore} from "Stores/Auth/types";
import {inject, observer} from "mobx-react";
import {
    MetaDataTabItem
} from "@src/Components/Pages/Main/Content/Locations/LocationDialog/MetaDataTab/MetaDataTabItem/MetaDataTabItem";
import {computed} from "mobx";
import {IValuesStore} from "Stores/Values/types";
import {IError} from "@src/Components/Pages/Main/Content/Locations/LocationDialog/LocationDialog";
import {AddButton} from "@src/Shared/Components/AddButton/AddButton";

export interface ISelectedItem {
    typeValue: number;
    typeName: string;
}

interface IMetaDataTab {
    tableHeight: number;
    location: Location;
    metaData: MetaData[];
    errors: IError[];
    onChange: (data: MetaData[]) => void;
    auth?: IAuthStore;
    values?: IValuesStore;
}

@inject("auth", "values")
@observer
export class MetaDataTab extends React.Component<IMetaDataTab> {

    @computed get metaDataTypes() {
        const resultTypes: ISelectedItem[] = [];
        Object.entries(this.props.values.metaDataTypes || {}).map(type => {
            resultTypes.push({
                typeName: type[0],
                typeValue: type[1],
            });
        });
        return resultTypes.sort((a, b) => a.typeValue - b.typeValue);
    }

    onAddMetaDataBtnClick() {
        const newMetaData = new MetaData();
        newMetaData.type = 0;
        newMetaData.isNew = true;
        this.props.onChange([...this.props.metaData, newMetaData]);
    }

    onMetaDataChange(data: MetaData, index: number) {
        const updatedMetaData = this.props.metaData;
        updatedMetaData[index] = data;
        this.props.onChange(updatedMetaData);
    }

    onMetaDataRemove(index: number) {
        const updatedMetaData = this.props.metaData;
        updatedMetaData.splice(index, 1);
        this.props.onChange(updatedMetaData);
    }

    getMetadataDefaultValue(type: number) {
        if ((type === 4 || type === 5) && this.canChangeValues(type, false)) {
            const today = new Date();
            const dateString = today.toISOString().substring(0, 10);
            return dateString + (type === 5 ? "T00:00" : "");
        } else {
            return "";
        }
    }

    onMetaDataTypeChange(type: number, index: number) {
        const metadataItem = this.props.metaData[index];
        metadataItem.type = type;
        metadataItem.value = this.getMetadataDefaultValue(type);

        this.onMetaDataChange(metadataItem, index);
    }
    
    canAddAndEdit() {
        return !this.props.location
            ? true
            : this.props.auth.user.location.primary;
    }

    canChangeValues(type: number, isNew: boolean) {
        if (type === 0) {
            return this.props.auth.user.location.primary && isNew;
        } else {
            return this.props.auth.user.location.id === this.props.location.id;
        }
    }

    render() {
        return (
            <Container style={{padding: 0}}>
                <TableContainer
                    style={{maxHeight: `${this.props.tableHeight}px`, overflowY: "auto"}}>
                    <Table>
                        <TableHead style={{backgroundColor: "#f9f9f9"}}>
                            <TableRow>
                                <TableCell style={{width: "25%"}}>{Values.getLocalizationValue("name")}</TableCell>
                                <TableCell style={{width: "30%"}}>{Values.getLocalizationValue("type")}</TableCell>
                                <TableCell style={{width: "30%"}}>{Values.getLocalizationValue("value")}</TableCell>
                                <TableCell/>
                            </TableRow>
                        </TableHead>

                        {(this.props.metaData.length > 0)
                            ? <TableBody>
                                {this.props.metaData
                                    && this.props.metaData.map((item, index) => (
                                        <MetaDataTabItem
                                            key={index}
                                            metaData={item}
                                            metaDataTypes={this.metaDataTypes}
                                            error={this.props.errors.find(item => item.index === index)}
                                            canEdit={this.canAddAndEdit()}
                                            canChangeValues={this.canChangeValues(item.type, item.isNew)}
                                            canEditDropdownOptions={this.props.auth.user.location.primary}
                                            onRemove={() => this.onMetaDataRemove(index)}
                                            onChange={(data) => this.onMetaDataChange(data, index)}
                                            onTypeChange={(type) => this.onMetaDataTypeChange(type, index)}
                                        />
                                    ))}
                            </TableBody>

                            : <NoContentSign style={{whiteSpace: "nowrap"}}>
                                {Values.getLocalizationValue("listOfMetadataIsEmpty")}
                            </NoContentSign>
                        }
                    </Table>
                </TableContainer>
                
                {this.canAddAndEdit()
                    ? <AddButton
                        onClick={() => this.onAddMetaDataBtnClick()}
                        text={Values.getLocalizationValue("addMetaData")}
                        margin={16}
                    />
                    
                    : <div style={{height: 80}}/>
                }
            </Container>
        );
    }
}
